import React, { useState } from "react";
import jsPDF from "jspdf";
import img1 from "../../../../assets/images/logo_metroFull.png";
import dayjs from "dayjs";
import { getUser } from "../../../../utils/getUser";
import { getProtocolDisplayLabel } from "../../../../utils/protocolDisplayLabel";
import { Button } from "antd";
import { FilePdfOutlined } from "@ant-design/icons";
import { message } from "antd";

const EjemploPdf = ({ itemsGeneral, users }) => {
  const [loading, setLoading] = useState(false);
  const formatDate = (date) =>
    date ? dayjs(date).format("MMM DD, YYYY hh:mm:ss A") : "Sin fecha";

  const estadoFiltros = {
    Created: "Creado",
    Started: "Iniciado",
    Completed: "Completado",
    FalseAlarm: "Falsa alarma",
    Skipped: "Saltada",
    Closed: "Cerrado",
  };

  const FormatearMoneda = (valor) => {
    const valorFormateado = new Intl.NumberFormat("es-CO", {
      style: "decimal",
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(valor);

    return valorFormateado;
  };

  const addFirstPageContent = (pdf, itemsGeneral) => {
    let yPos = 50; // Posición inicial
    const margin = 10;
    const pageWidth = pdf.internal.pageSize.getWidth();
    const leftColumnX = margin;
    const rightColumnX = pageWidth / 2 + margin;
    const lineHeight = 10;

    // COLUMNA IZQUIERDA - Información del Evento
    pdf.setFont("helvetica", "bold");
    pdf.text("Información del Evento:", leftColumnX, yPos);
    yPos += 8;

    pdf.setFont("helvetica", "normal");
    const eventState = estadoFiltros[itemsGeneral?.state] || "No disponible";
    pdf.text(`Estado:`, leftColumnX, yPos);

    // Tag visual para el estado del evento
    const eventStateText = `${eventState}`;
    const eventStateTextWidth = pdf.getTextWidth(eventStateText);
    const eventStateX = leftColumnX + 40; // Posición después de "Estado: "

    // Configurar estilo para el tag de estado del evento
    pdf.setFontSize(9);
    pdf.setFont("helvetica", "bold");

    // Color de fondo para el tag según el estado
    if (eventState === "Falsa alarma") {
      pdf.setFillColor(244, 67, 54); // Rojo sutil
    } else if (eventState === "Cerrado") {
      pdf.setFillColor(33, 150, 243); // Azul
    } else if (eventState === "Iniciado") {
      pdf.setFillColor(255, 152, 0); // Naranja
    } else if (eventState === "Completado") {
      pdf.setFillColor(76, 175, 80); // Verde
    } else {
      pdf.setFillColor(158, 158, 158); // Gris
    }

    // Dibujar rectángulo de fondo para el tag
    const tagPadding = 2;
    const tagHeight = 5;
    pdf.rect(
      eventStateX - tagPadding,
      yPos - tagHeight + 2,
      eventStateTextWidth + tagPadding * 2,
      tagHeight,
      "F",
    );

    // Texto del tag en blanco
    pdf.setTextColor(255, 255, 255);
    pdf.text(eventStateText, eventStateX, yPos);
    pdf.setTextColor(0, 0, 0); // Restaurar color negro

    yPos += 8;

    // Causa del evento (tomar la primera causa si existe)
    const firstCause = itemsGeneral?.causes?.[0];
    const causeText = firstCause?.protocol_cause
      ? firstCause.protocol_cause
          .replace(/[_-]/g, " ")
          .replace(/\s+/g, " ")
          .trim()
      : "No disponible";

    // Dividir el texto de la causa en múltiples líneas si es muy largo
    const causeLines = pdf.splitTextToSize(causeText, pageWidth / 2 - margin);
    causeLines.forEach((line, index) => {
      if (index === 0) {
        pdf.text(`Causa: ${line}`, leftColumnX, yPos);
      } else {
        pdf.text(`      ${line}`, leftColumnX, yPos);
      }
      yPos += 8;
    });

    pdf.text(
      `Fuente de Información: ${itemsGeneral?.source || "No disponible"}`,
      leftColumnX,
      yPos,
    );
    yPos += 8;

    pdf.text(
      `Tipo de Riesgo: ${itemsGeneral?.impact || "No disponible"}`,
      leftColumnX,
      yPos,
    );
    yPos += 8;

    // pdf.text(
    //   `Creado por: ${getUser(itemsGeneral.createdBy, UsuariosList)}`,
    //   leftColumnX,
    //   yPos
    // );
    yPos += 8;

    // COLUMNA DERECHA - Información de Ubicación
    yPos = 50; // Reiniciar posición vertical
    pdf.setFont("helvetica", "bold");
    pdf.text("Información de Ubicación:", rightColumnX, yPos);
    yPos += 8;

    pdf.setFont("helvetica", "normal");
    pdf.text(
      `Ubicación: ${itemsGeneral?.location?.name || "No disponible"}`,
      rightColumnX,
      yPos,
    );
    yPos += 8;

    pdf.text(
      `Lugar: ${itemsGeneral?.location?.specific || "No disponible"}`,
      rightColumnX,
      yPos,
    );
    yPos += 8;

    pdf.text(
      `Zona: ${itemsGeneral?.location?.zone || "No disponible"}`,
      rightColumnX,
      yPos,
    );
    yPos += 8;

    pdf.text(
      `Tipo: ${itemsGeneral?.location?.type || "No disponible"}`,
      rightColumnX,
      yPos,
    );
    yPos += 8;

    pdf.text(
      `Medio: ${itemsGeneral?.location?.means || "No disponible"}`,
      rightColumnX,
      yPos,
    );
    yPos += 8;

    // Fechas en la parte inferior
    yPos = Math.max(yPos, 90); // Asegurar que esté alineado
    pdf.setFont("helvetica", "bold");
    pdf.text(
      `Inicio: ${formatDate(itemsGeneral?.stateHistory?.Open?.date)}`,
      leftColumnX,
      yPos,
    );
    pdf.text(
      `Cierre: ${formatDate(
        itemsGeneral?.stateHistory?.Closed?.date ||
          itemsGeneral?.stateHistory?.FalseAlarm?.date,
      )}`,
      rightColumnX,
      yPos,
    );
    yPos += 5;
    // Fechas en la parte inferior
    yPos = Math.max(yPos, 90); // Asegurar que esté alineado
    pdf.setFont("helvetica", "bold");
    pdf.text(
      `Usuario: ${getUser(itemsGeneral?.stateHistory?.Open?.userId, users)}`,
      leftColumnX,
      yPos,
    );
    pdf.text(
      `Usuario: ${getUser(
        itemsGeneral?.stateHistory?.Closed?.userId ||
          itemsGeneral?.stateHistory?.FalseAlarm?.userId,
        users,
      )}`,
      rightColumnX,
      yPos,
    );
    yPos += 10;

    // Añadir subtítulo "Informe"
    pdf.setFont("helvetica", "bold");
    pdf.setFontSize(14);
    pdf.text("Informe", margin, yPos);
    yPos += 8;

    // Texto del informe
    pdf.setFont("helvetica", "normal");
    pdf.setFontSize(12);
    const reportText =
      "Este es el informe detallado del evento. Aquí se especifica la naturaleza del evento, las circunstancias y cualquier detalle relevante.";
    pdf.text(reportText, margin, yPos, { maxWidth: pageWidth - margin * 2 });
    yPos += 20; // Espacio después del texto

    const addTextWithHeading = (heading, text, yPos) => {
      pdf.setFont("helvetica", "bold");
      pdf.text(heading, margin, yPos);
      pdf.setFont("helvetica", "normal");
      const lines = pdf.splitTextToSize(text, pageWidth - margin * 2);
      lines.forEach((line) => {
        if (yPos + lineHeight > pdf.internal.pageSize.height - margin) {
          pdf.addPage();
          yPos = margin; // Reiniciar la posición vertical en la nueva página
        }
        pdf.text(line, margin + 20, yPos);
        yPos += lineHeight;
      });
      return yPos; // Retornar la posición vertical actualizada
    };
    yPos = addTextWithHeading(
      "Costo:",
      FormatearMoneda(itemsGeneral.cost.total),
      yPos,
    );
    yPos = addTextWithHeading(
      "Descripción:",
      itemsGeneral?.cost?.description || " ",
      yPos,
    );

    // Causas Asociadas
    const causes = itemsGeneral?.causes || [];

    if (causes.length > 0) {
      // Verificar espacio para el título de causas
      if (yPos + 15 > pdf.internal.pageSize.height - margin) {
        pdf.addPage();
        yPos = margin;
      }

      pdf.setFont("helvetica", "bold");
      pdf.text("Causas Asociadas:", margin, yPos);
      pdf.setFont("helvetica", "normal");
      yPos += lineHeight;

      causes.forEach((cause, index) => {
        // Limpiar caracteres especiales del nombre de la causa
        const cleanCauseName = cause?.protocol_cause
          ? cause.protocol_cause
              .replace(/[_-]/g, " ") // Reemplazar guiones bajos y medios con espacios
              .replace(/\s+/g, " ") // Reemplazar múltiples espacios con uno solo
              .trim() // Eliminar espacios al inicio y final
          : "Sin causas asignadas";

        const causeText = `Causa del evento: ${cleanCauseName}`;
        const causeLines = pdf.splitTextToSize(
          causeText,
          pageWidth - margin * 2,
        );

        causeLines.forEach((line) => {
          if (yPos + lineHeight > pdf.internal.pageSize.height - margin) {
            pdf.addPage();
            yPos = margin;
          }
          pdf.text(line, margin + 20, yPos);
          yPos += lineHeight;
        });

        // Mostrar participantes de la causa
        yPos += 5; // Espacio antes de los participantes

        if (cause?.participants && cause.participants.length > 0) {
          // Verificar espacio para el título de participantes
          if (yPos + 15 > pdf.internal.pageSize.height - margin) {
            pdf.addPage();
            yPos = margin;
          }

          // Título de participantes
          pdf.setFont("helvetica", "bold");
          pdf.setFontSize(10);
          pdf.text("Participantes:", margin + 20, yPos);
          yPos += 6;

          // Lista de participantes
          pdf.setFont("helvetica", "normal");
          pdf.setFontSize(9);

          cause.participants.forEach((participant, pIndex) => {
            const participantInfo = [];

            // ID del participante
            if (participant.id) {
              participantInfo.push(`ID: ${participant.id}`);
            }

            // Nombre del participante
            if (participant.name) {
              participantInfo.push(`Nombre: ${participant.name}`);
            }

            // Rol del participante
            if (participant.role) {
              participantInfo.push(`Rol: ${participant.role}`);
            }

            // Si no hay información específica, mostrar solo el ID
            if (participantInfo.length === 0) {
              participantInfo.push(
                `Participante ${pIndex + 1}: ${participant}`,
              );
            }

            const participantText = participantInfo.join(" | ");
            const participantLines = pdf.splitTextToSize(
              participantText,
              pageWidth - margin * 2 - 20,
            );

            participantLines.forEach((line) => {
              if (yPos + lineHeight > pdf.internal.pageSize.height - margin) {
                pdf.addPage();
                yPos = margin;
              }
              pdf.text(line, margin + 30, yPos);
              yPos += 5;
            });

            yPos += 3; // Espacio entre participantes
          });
        } else {
          // Verificar espacio para el mensaje de no participantes
          if (yPos + 10 > pdf.internal.pageSize.height - margin) {
            pdf.addPage();
            yPos = margin;
          }

          // Mensaje cuando no hay participantes
          pdf.setFont("helvetica", "italic");
          pdf.setFontSize(9);
          pdf.text("No hay participantes registrados", margin + 20, yPos);
          yPos += 6;
        }

        yPos += lineHeight; // Espacio después de cada causa
      });
    }
  };

  const addHeader = (pdf, item) => {
    pdf.addImage(img1, "PNG", 10, 10, 20, 30); // x, y, width, height
    pdf.setFont("helvetica");
    pdf.setFontSize(24);
    pdf.setTextColor(40);
    pdf.text(`Información General - ${item?.id || "cise-xxxx-xxx"}`, 35, 25); // x, y
    pdf.setFontSize(12);
    pdf.text(
      `Fecha de creación del informe: ${dayjs().format(
        "MMM DD, YYYY hh:mm:ss A",
      )}`,
      35,
      15,
    ); // x, y
  };

  const addSecondPageContent = (pdf, itemProtocol, itemsGeneral) => {
    // Configuración inicial
    const margin = 10;
    const pageWidth = pdf.internal.pageSize.getWidth();
    const columnWidth = (pageWidth - margin * 2) / 2;
    let yPos = 20; // Posición inicial después del encabezado

    // Añadir título
    const protocolLabel = getProtocolDisplayLabel(
      itemProtocol?.protocol,
      itemsGeneral?.causes,
    );
    pdf.setFont("helvetica", "bold");
    pdf.setFontSize(14);
    pdf.text(
      `PARP ${protocolLabel} - (${itemProtocol?.eventId})`,
      margin,
      yPos,
    );
    yPos += 10; // Espacio después del título

    // Configuración de la tabla
    const rowHeight = 8; // Altura de fila
    const columnHeaders = [
      "Estado del evento:" + estadoFiltros[itemProtocol?.state] || "NA",
      "",
    ];
    const rows = [
      [
        `Inicio: ${formatDate(itemProtocol?.stateHistory?.Created?.date)}`,
        `Cierre: ${formatDate(
          itemProtocol?.stateHistory?.Completed?.date ||
            itemProtocol?.stateHistory?.FalseAlarm?.date ||
            itemProtocol?.stateHistory?.Skipped?.date,
        )}`,
      ],
      [
        "Iniciador: " +
          getUser(itemProtocol.stateHistory.Created.userId, users),
        "Finalizador: " +
          getUser(
            itemProtocol?.stateHistory?.Completed?.userId ||
              itemProtocol?.stateHistory?.FalseAlarm?.userId,
            users,
          ),
      ],
    ];

    // Añadir encabezados de columna
    pdf.setFont("helvetica", "bold");
    pdf.setFontSize(12);
    pdf.text(columnHeaders[0], margin, yPos);
    pdf.text(columnHeaders[1], margin + columnWidth, yPos);
    yPos += rowHeight;

    // Añadir filas de la tabla
    pdf.setFont("helvetica", "normal");
    rows.forEach((row) => {
      pdf.text(row[0], margin, yPos);
      pdf.text(row[1], margin + columnWidth, yPos);
      yPos += rowHeight;
    });

    // Añadir espacio adicional para asegurar que el contenido no se solape
    yPos += 5;

    pdf.setFont("helvetica", "bold");
    pdf.setFontSize(16);
    pdf.text("Actividades del Evento", margin, yPos);
    yPos += 5;

    return yPos; // Retornar la posición vertical actualizada
  };

  const renderActivityBlocks = (
    activities,
    pdf,
    margin,
    yPos,
    pageHeight,
    startIndex = 0,
  ) => {
    const tituloAct = (tituloProtocolo) => {
      let nombre = tituloProtocolo[1].replace(/-/g, " ") || "act 1";

      if (tituloProtocolo.length === 4) {
        nombre = tituloProtocolo[2].replace(/-/g, " ");
      }
      return nombre;
    };

    // Función para obtener el estado de la actividad
    const getActivityState = (activity) => {
      if (activity.stateHistory?.Completed) return "COMPLETADO";
      if (activity.stateHistory?.Closed) return "CERRADO";
      if (activity.stateHistory?.Started) return "EN CURSO";
      if (activity.stateHistory?.Created) return "CREADO";
      return "PENDIENTE";
    };

    // Verificar si hay actividades para renderizar
    if (!activities || activities.length === 0) {
      return yPos;
    }

    activities.forEach((activity, localIndex) => {
      const globalIndex = startIndex + localIndex; // Índice global para numeración consecutiva
      const leftColumnX = margin;
      const rightColumnX = pdf.internal.pageSize.getWidth() / 2;
      const tituloProtocolo = activity.protocol_activity_subactivity.split("_");

      // Verificar si hay espacio suficiente para toda la actividad
      if (yPos + 25 > pageHeight - margin) {
        pdf.addPage();
        yPos = margin;
      }

      // Título de la actividad con numeración consecutiva
      pdf.setFontSize(13);
      pdf.setFont("helvetica", "bold");
      const activityTitle = `${globalIndex + 1}. ${tituloAct(tituloProtocolo)}`;
      pdf.text(activityTitle, margin, yPos);

      // Estado de la actividad como tag en el lado derecho
      const activityState = getActivityState(activity);
      const stateText = `${activityState}`;
      const stateTextWidth = pdf.getTextWidth(stateText);
      const stateX = pdf.internal.pageSize.getWidth() - margin - stateTextWidth;

      // Configurar estilo para el tag de estado
      pdf.setFontSize(10);
      pdf.setFont("helvetica", "bold");

      // Color de fondo para el tag según el estado
      if (activityState === "COMPLETADO") {
        pdf.setFillColor(76, 175, 80); // Verde
      } else if (activityState === "CERRADO") {
        pdf.setFillColor(33, 150, 243); // Azul
      } else if (activityState === "EN CURSO") {
        pdf.setFillColor(255, 152, 0); // Naranja
      } else {
        pdf.setFillColor(158, 158, 158); // Gris
      }

      // Dibujar rectángulo de fondo para el tag
      const tagPadding = 2;
      const tagHeight = 6;
      pdf.rect(
        stateX - tagPadding,
        yPos - tagHeight + 2,
        stateTextWidth + tagPadding * 2,
        tagHeight,
        "F",
      );

      // Texto del tag en blanco
      pdf.setTextColor(255, 255, 255);
      pdf.text(stateText, stateX, yPos);
      pdf.setTextColor(0, 0, 0); // Restaurar color negro

      yPos += 6;

      // Información de fechas en una sola línea más compacta
      pdf.setFontSize(10);
      pdf.setFont("helvetica", "normal");

      const startDate =
        formatDate(activity.stateHistory?.Started?.date) || "Sin fecha";
      const endDate =
        formatDate(activity.stateHistory?.Completed?.date) || "Sin fecha";

      pdf.text(`Inicio: ${startDate}`, leftColumnX, yPos);
      pdf.text(`Cierre: ${endDate}`, rightColumnX, yPos);
      yPos += 5;

      // Comentario con mejor formato
      if (activity.comments && activity.comments.length > 0) {
        const commentText = activity.comments[0].comment || "No disponible";

        // Verificar si hay espacio para el comentario
        if (yPos + 15 > pageHeight - margin) {
          pdf.addPage();
          yPos = margin;
        }

        pdf.setFont("helvetica", "bold");
        pdf.setFontSize(9);
        pdf.text("Comentario:", margin, yPos);
        yPos += 4;

        pdf.setFont("helvetica", "normal");
        pdf.setFontSize(9);

        // Usar un ancho más reducido para el comentario para evitar que supere A4
        const commentWidth = pdf.internal.pageSize.getWidth() - margin * 2 - 20; // Reducir 20mm adicionales
        const commentLines = pdf.splitTextToSize(commentText, commentWidth);

        commentLines.forEach((line) => {
          // Verificar espacio para cada línea del comentario
          if (yPos + 4 > pageHeight - margin) {
            pdf.addPage();
            yPos = margin;
          }
          pdf.text(line, margin + 10, yPos);
          yPos += 4;
        });
      }

      // Referencias multimedia después de comentarios
      if (activity.references && activity.references.length > 0) {
        // Verificar si hay espacio para las referencias
        if (yPos + 10 > pageHeight - margin) {
          pdf.addPage();
          yPos = margin;
        }

        pdf.setFont("helvetica", "bold");
        pdf.setFontSize(9);
        pdf.text("Multimedia Adicionada:", margin, yPos);
        yPos += 4;

        pdf.setFont("helvetica", "normal");
        pdf.setFontSize(8);

        activity.references.forEach((reference, refIndex) => {
          const refText = `• ${
            reference.name || reference.fileName || `Archivo ${refIndex + 1}`
          }`;

          // Verificar espacio para cada referencia
          if (yPos + 4 > pageHeight - margin) {
            pdf.addPage();
            yPos = margin;
          }

          pdf.text(refText, margin + 10, yPos);
          yPos += 3;
        });
      }

      // Espacio más compacto entre actividades
      yPos += 6;

      // Línea separadora sutil entre actividades (solo si no es la última actividad global)
      if (localIndex < activities.length - 1) {
        pdf.setDrawColor(200, 200, 200);
        pdf.line(margin, yPos, pdf.internal.pageSize.getWidth() - margin, yPos);
        yPos += 3;
      }
    });

    return yPos;
  };

  const ajusteArray = (data) => {
    const sortedData = data.sort((a, b) => {
      const orderA = parseFloat(a.order);
      const orderB = parseFloat(b.order);

      // Comparar los valores como números
      return orderA - orderB;
    });

    return sortedData;
  };

  // Función para generar el PDF
  const generatePDF = () => {
    // Validar que los datos necesarios estén disponibles
    if (!itemsGeneral) {
      message.error("No hay datos disponibles para generar el PDF");
      return;
    }

    if (!itemsGeneral.protocols || itemsGeneral.protocols.length === 0) {
      message.error("No hay protocolos disponibles para generar el PDF");
      return;
    }

    setLoading(true);
    try {
      const pdf = new jsPDF("p", "mm", "a4");
      const pageHeight = pdf.internal.pageSize.getHeight();
      const margin = 10;
      let yPos = margin;

      // Añadir cuerpo de la primera página
      addHeader(pdf, itemsGeneral);
      addFirstPageContent(pdf, itemsGeneral);

      // Verificar si hay actividades antes de crear la segunda página
      const ordenActividades = ajusteArray(
        itemsGeneral.protocols[0].activities,
      );

      if (ordenActividades.length > 0) {
        // Solo crear nueva página si hay actividades para mostrar
        pdf.addPage();
        yPos = addSecondPageContent(
          pdf,
          itemsGeneral.protocols[0],
          itemsGeneral,
        );
        yPos += 5;

        // Renderizar todas las actividades de forma continua
        yPos = renderActivityBlocks(
          ordenActividades,
          pdf,
          margin,
          yPos,
          pageHeight,
          0,
        );
      }

      setLoading(false);
      pdf.save(
        `Informe_General_Evento_${itemsGeneral?.id || "cise-xxxx-xxx"}.pdf`,
      );
      message.success("PDF generado y descargado exitosamente");
    } catch (error) {
      console.error("Error al generar PDF:", error);
      message.error("Error al generar el PDF. Inténtalo de nuevo.");
      setLoading(false);
    }
  };

  return (
    <div style={{ marginBottom: "16px" }}>
      <Button
        loading={loading}
        onClick={generatePDF}
        type="primary"
        icon={<FilePdfOutlined />}
        size="large"
        disabled={
          !itemsGeneral ||
          !itemsGeneral.protocols ||
          itemsGeneral.protocols.length === 0
        }
        style={{
          width: "100%",
          height: "40px",
          borderRadius: "6px",
          fontWeight: "500",
          boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
        }}
      >
        {loading ? "Generando PDF..." : "Descargar Informe PDF"}
      </Button>
    </div>
  );
};

export default EjemploPdf;
